export default {
  ApplicationNAME: 'Admin Bank',
  ApplicationAPI: 'https://api.fgghgfhfhgfdgdfsddfvdfonline.life/api/v1/admin',
  ApplicationPublicURL: 'https://api.fgghgfhfhgfdgdfsddfvdfonline.life',
  Timezone: 'Europe/Moscow'
}
